import { IClient } from '@splitsoftware/splitio/types/splitio';

interface SplitIOptions {
  initializer: (key: string) => Promise<IClient>;
  isClient?: boolean;
}

interface GetTreatments {
  userKey: string;
  features: string[];
  userAttributes: {};
}

export default class SplitIOClient {
  static Events = {
    SDK_READY: 'init::ready',
    SDK_READY_TIMED_OUT: 'init::timeout',
    SDK_UPDATE: 'state::update',
    GET_TREATMENTS_START: 'getTreatments.start',
    GET_TREATMENTS_SUCCESS: 'getTreatments.done',
    GET_TREATMENTS_ERROR: 'getTreatments.error',
  };
  private initializer: (userKey: string) => Promise<IClient>;
  private clientPromise: Promise<IClient>;
  private isClient: boolean;

  constructor({ initializer, isClient }: SplitIOptions) {
    this.initializer = initializer;
    this.isClient = isClient || false;
  }

  getTreatments = ({ userKey, features, userAttributes }: GetTreatments) =>
    this.init(userKey).then(client => {
      client.emit(SplitIOClient.Events.GET_TREATMENTS_START);

      try {
        const treatments = this.isClient
          ? client.getTreatments(features, userAttributes)
          : client.getTreatments(userKey, features, userAttributes);

        client.emit(SplitIOClient.Events.GET_TREATMENTS_SUCCESS);

        return treatments;
      } catch {
        client.emit(SplitIOClient.Events.GET_TREATMENTS_ERROR);

        return {};
      }
    });

  private init = (userKey: string) => {
    if (!this.clientPromise) {
      this.clientPromise = this.initializer(userKey).then(client =>
        client.ready().then(() => client),
      );
    }

    return this.clientPromise;
  };
}
